import React from 'react'
import Header from './components/Header';
import Footer from './components/Footer';
import { useState,useEffect } from 'react';
import './styles/motoStyles.css';
import lotus from '../src/images/lotus.png';

const Corporate = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

    
    useEffect(() => {
      const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  return (
    <div>
      <div className={`moto ${fadeOut ? 'fade-out' : ''}`}>
        <h1>Corporate & Banking here at KWA</h1>
      </div>
      <Header scrolled={scrolled}/>
      <div className='justify-content-center d-flex align-items-center w-100 fs-4' style={{minHeight:'100vh',padding:'10%',paddingTop: '5%',paddingBottom: '5%'}}>
        <img src={lotus} alt='' className='lotus'></img>
        <div className=''><p>Greetings and welcome to <span className="kwa">KWA</span>, an institution distinguished for its legal prowess, where adeptness converges with precision within the domain of corporate and banking law. We take great pleasure in presenting our esteemed Corporate and Banking Division, renowned for their mastery of the intricate legal frameworks governing corporate entities and financial institutions in India.</p>
        <br />
        <p>Our <span className="highlight">Corporate and Banking</span> Division provides a comprehensive range of legal services meticulously tailored to meet the nuanced requirements of our esteemed clientele. With an unwavering commitment to compliance with statutory mandates and regulatory standards, our team adeptly navigates the complexities of corporate and banking law with finesse and efficacy.</p>
        <br />
        <p>At <span className="kwa">KWA</span>, we acknowledge the paramount importance of adherence to Indian statutes and regulatory frameworks. Our practice is firmly anchored in an unwavering dedication to upholding the highest standards of legal integrity, ensuring that our clients remain fully compliant with pertinent legislation, which includes, but is not limited to:</p>
        <p>
        The Companies Act, 2013: Enacted to regulate the incorporation, functioning, and dissolution of companies in India, with an emphasis on transparency, accountability, and investor protection.
        <br />
        <br />
        The Banking Regulation Act, 1949: Governs the banking sector in India, covering licensing, operational regulation, governance, and resolution of banking entities.
        <br />
        <br />
        The Reserve Bank of India Act, 1934: Grants regulatory authority to the Reserve Bank of India (RBI) over the banking and financial system, encompassing monetary policy, banking supervision, and currency issuance.</p>
        <br />
        <p>With a profound understanding of these statutes and their ramifications, our team offers strategic advice and representation to clients on a diverse range of corporate and banking matters. From <span className="highlight">corporate governance</span> and <span className="highlight">compliance</span> to <span className="highlight">mergers and acquisitions</span>, <span className="highlight">financing transactions</span>, and <span className="highlight">regulatory inquiries</span>, we provide tailor-made solutions aimed at optimizing outcomes while safeguarding our clients' interests.</p>
        <br />
        <p>We invite you to reach out to us today to explore how <span className="kwa">KWA’s</span> Corporate and Banking Division can support you in confidently and effectively navigating the complexities of corporate and banking law in India.</p></div>
      </div>
      <Footer />
    </div>
  )
}

export default Corporate
